export default "__VITE_ASSET__Bq4jgdE2__"